import React from 'react';
import { Grid } from '@mui/material';
import {
	BooleanInput,
	Create,
	NumberInput,
	SimpleForm,
	TextInput,
} from 'react-admin';

export const PlanCreate = (props: any) => {
	return (
		<Create {...props}>
			<SimpleForm>
				<Grid container spacing={2}>
					<Grid item xs={6}>
						<TextInput source="slug" required />
						<TextInput source="name" required />
						<TextInput source="stripeProductId" label="Stripe Product ID" />
						<NumberInput source="position" defaultValue={0} />
						<BooleanInput label="Enabled" source="enabled" defaultValue={true} />
					</Grid>
				</Grid>
			</SimpleForm>
		</Create>
	);
};
